import { getLinkedDocuments } from 'utils/getLinkedDocuments'
import { getDataAecModelDataDemo, getModulos } from 'utils/getModulosInfo'
import { IndexedDB } from 'utils/indexedDB/IndexedDb'
import { viewer } from 'utils/launchViewer'

const useLoadViewerData = options => {
  const { setExternalIdsMapping, setAllModulos } = options

  const processExternalIds = async externalIds => {
    setExternalIdsMapping?.(externalIds)
    // setExternalIds(externalIds) // * Esto creo que no se está usando

    console.time('Fetching AEC Model Data')
    const modelData = await getDataAecModelDataDemo()
    console.timeEnd('Fetching AEC Model Data')

    const linkedDocuments = getLinkedDocuments(modelData, externalIds)
    const modules = await getModulos(linkedDocuments)
    setAllModulos(modules)
  }

  const setViewerData = async () => {
    const modelId = viewer.model.getSeedUrn()
    console.time('Fetching ExternalIds')
    const cachedData = await IndexedDB.getAllIndexedDbChunks(modelId)

    if (cachedData?.length > 0) {
      console.timeEnd('Fetching ExternalIds')
      const completeData = Object.assign({}, ...cachedData)

      await processExternalIds(completeData)
    } else {
      viewer.model.getExternalIdMapping(async externalIds => {
        console.timeEnd('Fetching ExternalIds')
        await IndexedDB.saveToIndexedDB(modelId, externalIds)
        await processExternalIds(externalIds)
      })
    }
  }

  return { setViewerData }
}

export default useLoadViewerData
